"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLiveCMSEndpointURI = void 0;

var getLiveCMSEndpointURI = function getLiveCMSEndpointURI() {
  if (process.env.REACT_APP_DATA_ENDPOINT === 'nz-helix' || window.location.host.includes('nz')) {
    return 'nz-helix/v1';
  }

  return 'helix/v1';
};

exports.getLiveCMSEndpointURI = getLiveCMSEndpointURI;